import { newFrontendGuard } from './new-banking.guard';

/** `newFrontendGuard` for archive pages, on the Conservation version cookie. */
export const newConservationGuard = newFrontendGuard(partner => partner.conservationVersionCookie);
